/* eslint-disable import/no-anonymous-default-export */
import * as Types from "./types";
import _ from "lodash";
import moment from "moment";
import debugLog, {LogLevel} from "../utils/debugLog";

const initialState = {
  busData: [],
  schedules: [],
  locations: [],
  routeTags: [],
  allRouteLocations: [],
  allEtaSuccess: [],
  ntp: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Types.UPDATE_BUS_LOCATION:
      let busData: any[] = _.cloneDeep(state.busData);
      let locations: any[] = _.cloneDeep(state.locations);
      let allEtas: any[] = _.cloneDeep(state.allEtaSuccess);
      let ntp: any = _.cloneDeep(state.ntp);
      const now = moment().add(ntp, "minutes");

      const { data } = action.payload;

      (async () => {
        try {
          if (!data?.routeLocation?.id || !data?.route?.id) {
            return;
          }

          const filter: any = allEtas.filter((o: any) => o.routeId === data.route.id);
          //convert to object
          const results: any = filter[0];
          if (!results || !results.locationEtas) return;

          let startProcessing = false;
          let cumulativeTime = moment(
            data.eta,
            "YYYY-MM-DDTHH:mm:ss.SSSSZ"
          ).format("YYYY-MM-DD HH:mm:ss");

          const uniqueLocationEtas = new Map();
          for (let i = 0; i < results?.locationEtas.length; i++) {
            const locationEta = results?.locationEtas[i];

            // Check if we should start processing
            if (startProcessing === false) {
              if (locationEta.routeLocationId === data.routeLocation.id) {
                startProcessing = true;
                uniqueLocationEtas.set(locationEta.locationId, cumulativeTime);
              }
              continue; // Skip the rest of the loop until we start processing
            }

            if (!uniqueLocationEtas.has(locationEta.locationId)) {
              const getMinute = locationEta.second / 60;
              cumulativeTime = moment(cumulativeTime)
                .add(getMinute, "minutes")
                .format("YYYY-MM-DD HH:mm:ss");

              uniqueLocationEtas.set(locationEta.locationId, cumulativeTime);
            }
          }

          locations.forEach((item: any) => {
            let newEta;
            if (uniqueLocationEtas.has(item.locationId)) {
              newEta = {
                eta: uniqueLocationEtas.get(item.locationId),
                route: {
                  id: data.route.id,
                },
                expiredAt: now,
              };
            } else {
              newEta = {
                eta: null,
                route: {
                  id: data.route.id,
                },
                expiredAt: now,
              };
            }

            const index = item?.etas?.findIndex(
              (eta: any) => eta.route.id === data.route.id
            );

            if (index !== -1 && index !== undefined) {
              item.etas.splice(index, 1, newEta);
            } else {
              item.etas = item.etas || []; // Initialize item.etas if it doesn't exist
              item.etas.push(newEta);
            }
          });
        } catch (error) {
          debugLog(LogLevel.ERROR, 'Unable to get ETA.', {
              error: error,
          });
          
        }
      })();

      const indexToUpdate = _.findIndex(busData, (o: any) => {
        return o.assignment?.id === data?.assignment?.id;
      });

      const fakeIndexToUpdate = _.findIndex(busData, (o: any) => {
        return o.assignment?.id === (data?.assignment?.id ? data.assignment.id + 99999 : -1);
      });

      const estimatedBusToNextLocation = {
        ...data,
        assignment: { id: data?.assignment?.id ? data.assignment.id + 99999 : 0 },
        toLocation:
          data.nextLocation.id !== 0
            ? data.fromLocation === data.nextLocation
              ? data.fromLocation
              : data.nextLocation
            : 0,
        fromLocation: data.toLocation,
        hide: true,
        eta: moment(data.eta).add(5, "minutes"),
      };

      if (indexToUpdate !== -1) {
        busData[indexToUpdate] = data;

        if (fakeIndexToUpdate !== -1) {
          busData[fakeIndexToUpdate] = estimatedBusToNextLocation;
        }
      } else {
        if (data.nextLocation.id !== 0) {
          busData = [...busData, data, estimatedBusToNextLocation];
        } else {
          busData = [...busData, data];
        }
      }
      const filteredLocations = locations.filter(
        (location) => !_.isEmpty(location.busData)
      );
      let count = 0;

      const addItemToBusData = (routeId: any, id: any, locationId: any) => {
        busData.push({
          route: {
            id: routeId,
          },
          routeLocation: {
            id: id,
          },
          fromLocation: {
            id: locationId,
            lat: 0,
            lng: 0,
          },
          toLocation: {
            id: locationId,
            lat: 0,
            lng: 0,
          },
          hide: true,
        });
      };

      for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        let localCount = count + 1;
        if (filteredLocations[0]?.busData?.length > location?.busData?.length) {
          if (
            filteredLocations[0]?.busData?.length !== location?.busData?.length
          ) {
            filteredLocations[0]?.busData.forEach(
              () => {
                addItemToBusData(
                  location?.routeId,
                  location?.id,
                  location?.locationId
                );
              }
            );
          }
        }
        count = localCount;
      }

      busData.map((item: any) => {
        if (item?.vehicle?.id === data?.vehicle?.id) {
          item.vehicle.expiredAt = now;
        }
        return item;
      });

      return {
        ...state,
        busData,
        locations,
      };

    case Types.GET_BUS_ETA_SUCCESS:
      return {
        ...state,
        busData: action.payload.data,
      };
    case Types.GET_ALL_ETA_SUCCESS:
      return {
        ...state,
        allEtaSuccess: action.payload.data,
      };
    case Types.SET_NTP_SUCCESS:
      return {
        ...state,
        ntp: action.payload.data,
      };
    case Types.UPDATE_LOCATION_LIST:
      return {
        ...state,
        locations: action.payload.data,
      };
    case Types.GET_ROUTE_TAGS_SUCCESS:
      return {
        ...state,
        routeTags: action.payload.data,
      };
    case Types.GET_ALL_ROUTE_LOCATIONS:
      return {
        ...state,
        allRouteLocations: action.payload.data,
      };
    case Types.GET_ALL_ETA:
      return {
        ...state,
        allEta: action.payload.data,
      };
    default:
      return state;
  }
};
